import { render, staticRenderFns } from "./invoices-table.vue?vue&type=template&id=f212e7a2&scoped=true"
import script from "./invoices-table.vue?vue&type=script&lang=js"
export * from "./invoices-table.vue?vue&type=script&lang=js"
import style0 from "./invoices-table.vue?vue&type=style&index=0&id=f212e7a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f212e7a2",
  null
  
)

export default component.exports